
/* styles */
require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-b41ef4ba!postcss-loader!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AboutContent.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./AboutContent.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-b41ef4ba!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AboutContent.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/spa/About/AboutContent.vue
// module id = 71
// module chunks = 0